module.exports = __webpack_public_path__ + "static/pcb-logo-3fc9c94ee3e21ee4ac592037410df6c0.png";